import React from "react";
import WhoCharts from "./WhoCharts";
import { useSelector } from "react-redux";
import { formatDateRange } from "../../../utils/global-func";
function areAllWeeksEmpty(weeks) {
  return Object.values(weeks).filter((arr) => Array.isArray(arr));
}

const WhoAllCharts = () => {
  const data = useSelector((state) => state.dashboardReducer?.whoScoreData);

  if (!data) {
    return <div>Data not Found.......................</div>;
  }
  const isAllEmpty = data && areAllWeeksEmpty(data);
  const weeks = ["week1", "week2", "week3", "week4"];

  return (
    <div>
      {isAllEmpty?.length === 4 ? (
        <div className="flex justify-center mt-10 text-lg font-semibold text-balance">
          No data found
        </div>
      ) : (
        <>
          <div className="flex gap-4 lg:flex-col">
            {weeks.slice(0, 2).map((week, index) => {
              const weekData = data[week];
              if (!weekData?.sentTo && !weekData?.submission) {
                return null;
              } else {
                return (
                  <div className="w-[50%] lg:w-full" key={week}>
                    <WhoCharts
                      data={weekData?.graph || []}
                      text={formatDateRange(
                        weekData.startDate,
                        weekData.endDate
                      )}
                      sentTo={weekData?.sentTo}
                      submissions={weekData?.submission}
                    />
                  </div>
                );
              }
            })}
          </div>

          <div className="flex gap-4 mt-4 lg:flex-col">
            {weeks.slice(2, 4).map((week, index) => {
              const weekData = data[week];
              if (!weekData?.sentTo && !weekData?.submission) {
                return null;
              } else {
                return (
                  <div className="w-[50%] lg:w-full" key={week}>
                    <WhoCharts
                      data={weekData.graph || []}
                      text={formatDateRange(
                        weekData.startDate,
                        weekData.endDate
                      )}
                      sentTo={weekData?.sentTo}
                      submissions={weekData?.submission}
                    />
                  </div>
                );
              }
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default WhoAllCharts;
